export default __webpack_public_path__ + "static/media/growth.6f53d2bb.jpg";